export const defaultPaymentMethods = {
  bankTransfer: false,
  jazzCash: false,
  easyPaisa: false,
  stripe: false,
  square: false,
  manualPayment: false,
};

export const defaultApiKeys = {
  jazzCashMerchantId: '',
  jazzCashPassword: '',
  jazzCashIntegritySalt: '',
  easyPaisaStoreId: '',
  easyPaisaHashKey: '',
  easyPaisaAccountNumber: '',
  stripePublishableKey: '',
  stripeSecretKey: '',
  stripeWebhookSecret: '',
  stripeMode: 'test',
  squareApplicationId: '',
  squareAccessToken: '',
  squareLocationId: '',
  squareEnvironment: 'sandbox',
};

export const apiPaymentMethods = ['stripe', 'square'];

export const defaultApiConnections = {
  stripe: false,
  square: false,
};

export const defaultBankAccount = {
  bankName: '',
  accountTitle: '',
  accountNumber: '',
  iban: '',
  branchCode: '',
  swiftCode: '',
};

export const defaultMerchantInfo = {
  merchantName: '',
  merchantId: '',
  businessEmail: '',
  businessPhone: '',
  ntn: '',
  address: '',
  defaultCurrency: 'PKR',
};

export const paymentMethodMeta = [
  {
    key: 'bankTransfer',
    label: 'Enable Bank Transfer',
    description: 'Allow gyms to pay via direct bank transfer',
    icon: 'bank',
  },
  {
    key: 'jazzCash',
    label: 'Enable JazzCash',
    description: 'Accept payments through JazzCash mobile wallet',
    icon: 'jazzcash',
  },
  {
    key: 'easyPaisa',
    label: 'Enable EasyPaisa',
    description: 'Accept payments through EasyPaisa mobile account',
    icon: 'easypaisa',
  },
  {
    key: 'stripe',
    label: 'Enable Stripe',
    description: 'Accept card and online payments via Stripe API',
    icon: 'stripe',
    connectType: 'api',
  },
  {
    key: 'square',
    label: 'Enable Square',
    description: 'Accept in-person and online payments via Square',
    icon: 'square',
    connectType: 'api',
  },
  {
    key: 'manualPayment',
    label: 'Enable Manual Payment',
    description: 'Record offline payments manually',
    icon: 'manual',
  },
];

export const encryptionOptions = [
  { value: 'tls', label: 'TLS' },
  { value: 'ssl', label: 'SSL' },
  { value: 'none', label: 'None' },
];

export const currencyOptions = [
  { value: 'PKR', label: 'PKR' },
  { value: 'USD', label: 'USD' },
];

export const methodConfigFields = {
  bankTransfer: [
    { name: 'bankName', label: 'Bank Name', source: 'bank' },
    { name: 'accountTitle', label: 'Account Title', source: 'bank' },
    { name: 'accountNumber', label: 'Account Number', source: 'bank' },
    { name: 'iban', label: 'IBAN', source: 'bank' },
    { name: 'branchCode', label: 'Branch Code', source: 'bank' },
    { name: 'swiftCode', label: 'SWIFT Code', source: 'bank' },
  ],
  jazzCash: [
    { name: 'jazzCashMerchantId', label: 'Merchant ID' },
    { name: 'jazzCashPassword', label: 'Password', type: 'password' },
    { name: 'jazzCashIntegritySalt', label: 'Integrity Salt', type: 'password' },
  ],
  easyPaisa: [
    { name: 'easyPaisaStoreId', label: 'Store ID' },
    { name: 'easyPaisaHashKey', label: 'Hash Key', type: 'password' },
    { name: 'easyPaisaAccountNumber', label: 'Account Number' },
  ],
  stripe: [
    { name: 'stripePublishableKey', label: 'Publishable Key', placeholder: 'pk_test_...' },
    { name: 'stripeSecretKey', label: 'Secret Key', type: 'password', placeholder: 'sk_test_...' },
    { name: 'stripeWebhookSecret', label: 'Webhook Secret', type: 'password', placeholder: 'whsec_...' },
    { name: 'stripeMode', label: 'Mode', type: 'select', options: ['test', 'live'] },
  ],
  square: [
    { name: 'squareApplicationId', label: 'Application ID', placeholder: 'sq0idp-...' },
    { name: 'squareAccessToken', label: 'Access Token', type: 'password', placeholder: 'EAAA...' },
    { name: 'squareLocationId', label: 'Location ID', placeholder: 'L...' },
    { name: 'squareEnvironment', label: 'Environment', type: 'select', options: ['sandbox', 'production'] },
  ],
  manualPayment: [
    { name: 'merchantName', label: 'Merchant Name', source: 'merchant' },
    { name: 'businessEmail', label: 'Business Email', source: 'merchant' },
    { name: 'businessPhone', label: 'Business Phone', source: 'merchant' },
  ],
};
